import { getAuthContext } from '../context/AuthContext';

const getAxios = () => getAuthContext().axiosInstance;

class UbigeoServiceObject {
    baseUrl = '/api/ubigeo';

    async getDepartamentos() {
        const res = await getAxios().get(`${this.baseUrl}/departamentos`);
        return res.data;
    }

    async getProvincias(departamento) {
        if (!departamento) return [];
        const res = await getAxios().get(`${this.baseUrl}/provincias/${encodeURIComponent(departamento)}`);
        return res.data;
    }

    async getDistritos(departamento, provincia) {
        if (!departamento || !provincia) return [];
        const res = await getAxios().get(`${this.baseUrl}/distritos/${encodeURIComponent(departamento)}/${encodeURIComponent(provincia)}`);
        return res.data;
    }

    async getUbigeo(ubigeo) {
        if (!ubigeo) return null;
        try {
            const res = await getAxios().get(`${this.baseUrl}/${encodeURIComponent(ubigeo)}`);
            return res.data;
        } catch (error) {
            return null; // Return null if not found
        }
    }
}

export const UbigeoService = new UbigeoServiceObject();